import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_62353496: FaireBrandEntity = {
  token: "b_62353496",
  type: "brand",
  name: "Kent Stetson Handbags",
  avatarUrl:
    "https://cdn.faire.com/fastly/2572265662fa2874ad7085bc854d07dedacbf22bbaa7093c923b9a54041d2ef9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f8b0d65afa165aaef5512ef06c38fa6d72f19a835ec92f78a0407daece9020a4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2572265662fa2874ad7085bc854d07dedacbf22bbaa7093c923b9a54041d2ef9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f8b0d65afa165aaef5512ef06c38fa6d72f19a835ec92f78a0407daece9020a4.jpeg",
  location: "Pawtucket, RI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description:
    "I began making and selling handbags in 2003 as a way to sell my paintings- the bag was a perfect framing device that made my art more interactive.  Where I started working from my paintings, I have since incorporated photographs and various themes in to the collection.  Our pieces do not get the silent treatment! They break the ice with their distinct and approachable quality.  There are nearly 50 steps that go in to crafting each piece and we have a devoted following of collectors worldwide.  Celebrity owners include Martha Stewart, Megan Thee Stallion, Sarah Jessica Parker, Bette Midler, Iris Apfel, and many many others.\n\nI hand craft each piece alongside my team of skilled artisans from my workshop in Rhode Island.  I am involved in the entire production process, and I sign each piece inside in the pocket as I sew them up.  \n\nOur signature collection pieces are cruelty-free, constructed of luxury quality coated canvas (the same material as the LV signature bags, although our finish is smoother and glossier).  The majority of our raw materials are made domestically, and we produce each piece to order, reducing waste and limiting quantities.\n\nFancy without being fussy, our pieces effortlessly go from denim to dressy and set the tone for a fun outing.  A wonderful heirloom keepsake or thoughtful gift, our pieces go on to light up the room and will remind pe",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:54.540Z",
    importedBy: "entity-db-cli",
  },
};
